<style>
    .title {
        display: flex;
        padding: 2em 0;
        margin: 1px solid red !important;
    }

    .title .label {
        margin: 0;
        font-size: 1.8em;
        font-weight: 400;
        color: #fff;
        /* border-right: 10px solid purple; */
        padding-right: 10px;
    }
</style>

<div class="title">
    <div class="label"><slot></slot></div>
    <div style="flex: 1"></div>
</div>